import { apiSlice } from "./apiSlice";
import { getCountriesSelection, resetCountriesSelection } from "../slice/configSlice";

export const configApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getCountries: builder.query({
      query: (params = null) => ({
        url: "api/conf/v1/countries/",
        params,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getCountriesSelection(result.data)))
          .catch(_ => {
            dispatch(resetCountriesSelection());
          });
      },
    }),
    getSubdivisions: builder.query({
      query: ({ params } = {}) => {
        if (!params) {
          return {
            url: null,
          };
        }
        return {
          url: `api/conf/v1/countries/${params}/subdivisions/`,
        };
      },
    }),
  }),
});

export const { useGetCountriesQuery, useLazyGetCountriesQuery, useGetSubdivisionsQuery } =
  configApiSlice;
